export const EFEITOS_TITULO = "O que acontece ao inativar";

export const TEXTOS = {
  titulo: "Inativar escopo padrão",
  subtitulo: "Essa ação tira o escopo padrão da escolha de obras novas.",
  confirmar: "Inativar escopo padrão",
  intro: "Você vai inativar este escopo padrão:",
  efeitos: (versao: string) => [
    `Vale só para a versão ${versao}. Nas outras versões, ele continua como está.`,
    "Deixa de aparecer na escolha de escopo macro das novas Obras, no Nova Obra e no Adicionar Escopo macro.",
    "As Obras e os escopos macro que já usam continuam com ele, sem mudar os valores.",
    'Nada é excluído: para usar de novo, marque "Mostrar inativos" e ative.',
  ],
};

export const SITUACAO_INATIVA = "INATIVO";

export const registro = (partes: (string | null | undefined)[], versao: string): string =>
  [...partes.filter((parte): parte is string => !!parte?.trim()), `versão ${versao}`].join(" · ");
